export const textSort = (a, b, direction = 1) => {
  if (a?.toLowerCase() < b?.toLowerCase()) {
    return -1 * direction;
  }
  if (a?.toLowerCase() > b?.toLowerCase()) {
    return 1 * direction;
  }
  return 0;
};
